import { Injectable, Type } from "@angular/core";
import { ENCODABLE_TYPE_ERRORS } from "shared/broker-client-services";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { IRateSubscriptionService, CHANNEL_RATE_SUBSCRIPTION } from "../IRateSubscriptionService";
import { RateSubscription } from "../model/RateSubscription";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class RateSubscriptionReplicaService implements IRateSubscriptionService {
  protected broker: ClientMessageBroker;
  protected readonly VALUE: CubiqTS.ConcreteEncodable;

  constructor(protected factory: ClientMessageBrokerFactory) {
    //  protected modelMarketDataType: Type<CubiqTS.ConcreteEncodable> = CubiqTS.MarketDataEventImpl
    this.VALUE = CubiqTS.ENCODABLE(CubiqTS.MarketDataEventImpl);
    this.broker = this.factory.createMessageBroker(CHANNEL_RATE_SUBSCRIPTION, true, true);
  }

  public hasSubscription(rateSubscription: RateSubscription): Promise<boolean> {
    let request = new UiArguments("hasSubscription");

    let arg1: FnArg = new FnArg(rateSubscription, PRIMITIVE);
    request.args = [arg1];

    return this.runOnService(request);
  }

  public getActiveSubscriptions(): Promise<Array<RateSubscription>> {
    let request = new UiArguments("getActiveSubscriptions");

    request.args = [];

    return this.runOnService(request);
  }

  public subscribe(subscription: RateSubscription): Promise<any> {
    let request = new UiArguments("subscribe");

    let arg1: FnArg = new FnArg(subscription, PRIMITIVE);
    request.args = [arg1];

    return this.runOnService(request, this.VALUE);
  }

  public unsubscribeWithCheck(rateSubscription: RateSubscription): Promise<any> {
    let request = new UiArguments("unsubscribeWithCheck");

    let arg1: FnArg = new FnArg(rateSubscription, PRIMITIVE);
    request.args = [arg1];

    return this.runOnService(request);
  }

  public unsubscribe(subscription: RateSubscription): Promise<any> {
    let request = new UiArguments("unsubscribe");

    let arg1: FnArg = new FnArg(subscription, PRIMITIVE);
    request.args = [arg1];

    return this.runOnService(request);
  }

  protected runOnService(request: UiArguments, assignable: any = null): Promise<any> {
    return new Promise<any>((res, rej) => {
      this.broker.runOnService(request, PRIMITIVE).then((value: any) => {
        if (value && value.enType && value.enType == ENCODABLE_TYPE_ERRORS) {
          rej(value);
        } else {
          if (assignable && value) {
            value = Object.assign(assignable, value);
          }
          res(value);
        }
      });
    });
  }
}
